import classNames from 'classnames';
import React, { useState } from 'react'
import WizardDateButton from '../../wizard-v2/components/WizardDateButton';
import format from '../../../utilities/format';
import { getWizardV2State } from '../../wizard-v2/wizardService';
import WizardXpButton from '../../wizard-v2/components/WizardXpButton';
import { t } from '../../../utilities/translator';
import { createPortal } from 'react-dom';

const WhenStepDesktop = ({
  months,
  onMonthClick,
  onCustomHolidayClick,
  form,
  holidays,
  when,
  onContinueClick,
  onLastMinuteDealsClick,
}) => {
  const [activeTab, setActiveTab] = useState('months');
  const stepConfig = getWizardV2State().whenStep;
  const [topHolidays, bottomHolidays] = holidays;
  const footerPortal = document.getElementById('wizard-next-button');

  return (
    <div className="self-start">
      <p className="mb-4 heading-large text-primary">{stepConfig.title}</p>
      <div className="slide-in-bottom">
        <div className="flex gap-2 items-center justify-center mb-8">
          <div className={classNames('wizard-tab', { 'wizard-tab--active': activeTab === 'months' })} onClick={() => setActiveTab('months')}>{t('onboarding.when.typeMonth')}</div>
          <div className={classNames('wizard-tab', { 'wizard-tab--active': activeTab === 'special' })} onClick={() => setActiveTab('special')}>{t('onboarding.when.typeSpecial')}</div>
        </div>
        {activeTab === 'months' && (
          <div className="animate-fade-in">
            <div className="wizard-when-step__months">
              {months.map((month) => (
                <WizardDateButton
                  key={format(month, 'MMM')}
                  label={format(month, 'MMM')}
                  subtext={format(month, 'yyyy')}
                  onClick={() => onMonthClick(format(month, 'M'))}
                  active={form.when.months.includes(format(month, 'M'))}
                />
              ))}
            </div>
            <p className="mt-6 body-medium font-medium text-tertiary">{stepConfig.subTitle}</p>
          </div>
        )}
        {activeTab === 'special' && (
          <div className="animate-fade-in wizard-when-step__special">
            {[...topHolidays, ...bottomHolidays].map((holiday, index) => (
              <WizardXpButton
                key={index}
                label={holiday.text}
                iconUrl={holiday.icon}
                onClick={() => onCustomHolidayClick(holiday)}
                active={when.customHoliday?.text === holiday.text}
                className="animate-fade-in"
              />
            ))}

            <WizardXpButton
                label={stepConfig.lastMinuteTitle}
                subtext={stepConfig.lastMinuteSubTitle}
                iconUrl="https://d16tr0byigrcd.cloudfront.net/hf/images/wizard/icon-lastminute.svg"
                className="wizard-lastminute-icon"
                onClick={onLastMinuteDealsClick}
                active={when.lastMinuteDeals}
              />
          </div>
        )}
        {footerPortal && createPortal(
          <button className="wizard-btn wizard-btn--next" onClick={onContinueClick}>
            {stepConfig.buttonText}
            <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
          </button>,
          footerPortal
        )}
      </div>
    </div>
  )
}

export default WhenStepDesktop
